/* ── DOMContentLoaded ── */
document.addEventListener('DOMContentLoaded', function () {
  var panel      = document.getElementById('jaba-pers-panel');
  var triggerBtn = document.getElementById('pdp-pers-btn');
  if (!panel || !triggerBtn) return;

  var config = {}, fonts = [], initials = [], variants = [];
  try { config   = JSON.parse(panel.dataset.config   || '{}'); } catch(e) {}

  // Edit mode state — set by openWithPrefill, consumed by save handler
  var editCartKey = null;
  try { fonts    = JSON.parse(panel.dataset.fonts    || '[]') || []; } catch(e) {}
  try { initials = JSON.parse(panel.dataset.initials || '[]') || []; } catch(e) {}
  try { variants = JSON.parse(panel.dataset.variants || '[]') || []; } catch(e) {}

  var formEl   = document.getElementById('pers-form-content');
  var closeBtn = panel.querySelector('.pers-close');
  var built    = false;
  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0822/4112/6612/files/';

  function esc(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function buildIfNeeded() { if (!built) { built = true; renderStep1(); } }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  function renderStep1() {
    var sides = config.engravingSides || [];
    var html = '<div style="padding:1rem">';
    html += '<p style="font-size:0.7rem;letter-spacing:0.12em;text-transform:uppercase;color:#666;margin-bottom:1rem">ADD ENGRAVING</p>';
    sides.forEach(function(side, idx) {
      html += '<div class="pers-side-card" data-value="' + esc(side.value) + '" data-side-idx="' + idx + '" style="border:1px solid #ddd;border-radius:3px;padding:14px 18px;cursor:pointer;margin-bottom:10px;display:flex;justify-content:space-between;align-items:center;">';
      html += '<div><div style="font-weight:600;font-size:0.9rem">' + esc(side.label) + '</div><div style="font-size:0.75rem;color:#888;margin-top:4px">' + esc(side.note||'') + '</div></div>';
      html += '<div style="font-size:0.85rem;color:#2c0f0f;font-weight:600">+$' + parseFloat(side.priceAdd||0).toFixed(2) + '</div>';
      html += '</div>';
    });
    html += '<button id="pers-continue-btn" disabled style="width:100%;background:#2c0f0f;color:#fff;padding:14px;border:none;cursor:pointer;opacity:0.4;margin-top:1rem;letter-spacing:0.08em;font-size:0.85rem">CONTINUE \u2192</button>';
    html += '</div>';
    formEl.innerHTML = html;

    var selectedSideObj = null;
    var continueBtn = document.getElementById('pers-continue-btn');

    formEl.querySelectorAll('.pers-side-card').forEach(function(card) {
      card.addEventListener('click', function() {
        formEl.querySelectorAll('.pers-side-card').forEach(function(c) { c.style.border='1px solid #ddd'; c.style.background=''; });
        card.style.border = '2px solid #2c0f0f';
        card.style.background = '#faf8f5';
        selectedSideObj = sides[parseInt(card.dataset.sideIdx)] || { value: card.dataset.value };
        continueBtn.disabled = false;
        continueBtn.style.opacity = '1';
      });
    });

    continueBtn.addEventListener('click', function() { if (selectedSideObj) renderStep2(selectedSideObj); });
  }

  function renderStep2(sideObj) {
    var sideValue = (typeof sideObj === 'string') ? sideObj : (sideObj.value || '');
    var sideLabel = (typeof sideObj === 'object' && sideObj.label) ? sideObj.label : sideValue;
    var isWallet  = (config.productType === 'long_wallet');
    var rawFields = (typeof sideObj === 'object' && Array.isArray(sideObj.fields) && sideObj.fields.length)
      ? sideObj.fields
      : (sideValue.toLowerCase().indexOf('both') !== -1 ? ['front', 'back'] : ['front']);

    var hasFonts = fonts.length > 0;
    var hasInits = initials.length > 0;
    var activeField = rawFields[0];
    var selections  = {};
    rawFields.forEach(function(fid) { selections[fid] = null; });
    var isMulti = rawFields.length > 1;

    var UI_LABELS    = { front: isWallet ? 'FRONT COVER TEXT' : (isMulti ? 'FRONT TEXT' : 'YOUR TEXT'), back: 'BACK TEXT', insideLeft: 'INSIDE LEFT TEXT', insideRight: 'INSIDE RIGHT TEXT' };
    var SAVE_NAMES   = { front: 'Front', back: 'Back', insideLeft: 'Inside Left', insideRight: 'Inside Right' };
    var TOGGLE_LABELS= { front: 'FRONT', back: 'BACK', insideLeft: 'INSIDE L', insideRight: 'INSIDE R' };

    function getInp(fid) { return document.getElementById('pfield-' + fid); }
    function getCtr(fid) { return document.getElementById('pcount-' + fid); }
    function getStyleEl(fid) { return document.getElementById('pstyle-' + fid); }

    function setFieldStyleLabel(fid, label) {
      var el = getStyleEl(fid);
      if (!el) return;
      if (label) { el.textContent = '\u2713 ' + label; el.style.color = '#8B6914'; }
      else { el.textContent = 'No style selected'; el.style.color = '#bbb'; }
    }

    function unlockFieldInput(fid, fontFamily) {
      var inp = getInp(fid);
      if (!inp) return;
      inp.removeAttribute('readonly');
      inp.style.background = '#fff';
      inp.style.color = '#321716';
      inp.style.cursor = 'text';
      inp.style.border = '1.5px solid #321716';
      inp.placeholder = hasFonts ? 'Enter your text...' : 'Example: 5 - Max';
      if (fontFamily) { inp.style.fontFamily = fontFamily; inp.style.fontSize = '1.1rem'; }
    }

    function activateField(fid) {
      activeField = fid;
      rawFields.forEach(function(f) {
        var inp = getInp(f);
        if (inp) inp.style.outline = (f === fid) ? '2px solid #2c0f0f' : 'none';
      });
      formEl.querySelectorAll('.pers-toggle-pill').forEach(function(btn) {
        var on = btn.dataset.field === fid;
        btn.style.background = on ? '#2c0f0f' : 'transparent';
        btn.style.color = on ? '#fff' : '#2c0f0f';
        btn.style.fontWeight = on ? '600' : '400';
      });
      refreshOutlines();
    }

    function refreshOutlines() {
      formEl.querySelectorAll('.pers-style-card').forEach(function(card) {
        var cId = card.dataset.cardId, cType = card.dataset.type;
        var outline = '2px solid transparent';
        rawFields.forEach(function(fid) {
          var sel = selections[fid];
          if (sel && sel.id === cId && sel.type === cType) {
            if (fid === activeField) outline = '2px solid #c9a96e';
            else if (outline === '2px solid transparent') outline = '2px dashed #c9a96e';
          }
        });
        card.style.outline = outline;
      });
    }

    function renderSummary() {
      var el = document.getElementById('pers-summary');
      if (!el || !isMulti) return;
      el.textContent = rawFields.map(function(fid) {
        var sel = selections[fid], name = SAVE_NAMES[fid] || fid;
        return '\u2713 ' + name + ': ' + (sel ? sel.label : 'not selected');
      }).join('   ');
    }

    function applyInitialLimit(fid, maxChars) {
      var inp = getInp(fid), ctr = getCtr(fid);
      if (!inp || !ctr) return;
      inp.maxLength = maxChars;
      if (inp.value.length > maxChars) inp.value = inp.value.slice(0, maxChars);
      ctr.textContent = inp.value.length + '/' + maxChars;
    }

    function _sharedFontGrid() {
      if (!hasFonts) return '';
      var h = '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:0.75rem">';
      fonts.forEach(function(f) {
        h += '<div class="pers-style-card" data-card-id="' + esc(f.id) + '" data-type="font" data-label="' + esc(f.label) + '" data-max="500" style="cursor:pointer;text-align:center;padding:12px 8px;border:1px solid #e0dbd4;outline:2px solid transparent;background:rgb(252,249,248);">';
        if (f.image) { h += '<img src="' + esc(f.image) + '" style="width:100%;height:50px;object-fit:contain;display:block;margin-bottom:6px">'; }
        else { h += '<span style="display:block;font-size:1.6rem;color:#1a1a1a;margin-bottom:6px;padding:8px;font-family:' + esc(f.fontFamily||'serif') + '">Abc</span>'; }
        h += '<span style="font-size:0.6rem;color:#666;text-transform:uppercase;letter-spacing:0.08em">' + esc(f.label) + '</span></div>';
      });
      return h + '</div>';
    }

    function _sharedInitGrid() {
      if (!hasInits) return '';
      var h = '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:0.75rem">';
      initials.forEach(function(ini) {
        var imgSrc = ini.image ? (ini.image.startsWith('http') ? ini.image : CDN_BASE + ini.image) : '';
        h += '<div class="pers-style-card" data-card-id="' + esc(ini.id) + '" data-type="initial" data-label="' + esc(ini.label) + '" data-max="' + (ini.maxChars||500) + '" data-hint="' + esc(ini.inputHint || '') + '" style="cursor:pointer;text-align:center;padding:12px 8px;border:1px solid #e0dbd4;outline:2px solid transparent;">';
        if (imgSrc) h += '<img src="' + esc(imgSrc) + '" style="width:100%;height:60px;object-fit:contain;display:block;margin-bottom:6px">';
        h += '<span style="font-size:0.6rem;color:#666;text-transform:uppercase;letter-spacing:0.08em">' + esc(ini.label) + '</span></div>';
      });
      return h + '</div>';
    }

    // Build HTML
    var html = '<div style="padding:1rem">';
    html += '<a href="#" id="pers-back-lnk" style="font-size:0.8rem;color:#2c0f0f;display:block;margin-bottom:1rem;text-decoration:none">\u2190 Back</a>';

    rawFields.forEach(function(fid) {
      var label = UI_LABELS[fid] || (fid.toUpperCase() + ' TEXT');
      html += '<div class="pers-field-wrap" data-field="' + fid + '">';
      html += '<label style="font-size:0.7rem;letter-spacing:0.1em;text-transform:uppercase;color:#888">' + label + '</label>';
      var _lockMsg = hasFonts ? '\u2193 Select a font style below first' : '\u2193 Tap the design below to start';
      html += '<input id="pfield-' + fid + '" maxlength="500" placeholder="' + _lockMsg + '" readonly style="width:100%;border:1px solid #e0dbd4;padding:12px;margin:6px 0 4px;box-sizing:border-box;font-size:0.9rem;outline:none;cursor:not-allowed;background:#f9f7f5;color:#aaa;">';
      html += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.75rem">';
      html += '<span id="pstyle-' + fid + '" style="font-size:11px;color:#bbb;">No style selected</span>';
      html += '<span id="pcount-' + fid + '" style="font-size:11px;color:#bbb;">0/500</span>';
      html += '</div></div>';
    });

    if (isMulti) {
      html += '<div style="display:flex;align-items:center;gap:8px;margin:1rem 0 0.75rem;flex-wrap:wrap">';
      html += '<span style="font-size:0.65rem;letter-spacing:0.1em;text-transform:uppercase;color:#999;margin-right:4px">Select style for:</span>';
      rawFields.forEach(function(fid, idx) {
        var lbl = TOGGLE_LABELS[fid] || (SAVE_NAMES[fid]||fid).toUpperCase();
        var isFirst = idx === 0;
        html += '<button class="pers-toggle-pill" data-field="' + fid + '" style="padding:5px 14px;border:1.5px solid #2c0f0f;border-radius:99px;cursor:pointer;font-size:0.7rem;letter-spacing:0.08em;background:' + (isFirst?'#2c0f0f':'transparent') + ';color:' + (isFirst?'#fff':'#2c0f0f') + ';font-weight:' + (isFirst?'600':'400') + ';">' + lbl + '</button>';
      });
      html += '</div>';
    }

    if (hasFonts && hasInits) {
      html += '<div style="display:flex;border-bottom:1px solid #ddd;margin-bottom:0.75rem"><button class="pers-tab-btn" data-tab="fonts" style="flex:1;padding:8px;border:none;background:none;cursor:pointer;font-size:0.8rem;border-bottom:2px solid #2c0f0f;font-weight:600">Font Style</button><button class="pers-tab-btn" data-tab="initials" style="flex:1;padding:8px;border:none;background:none;cursor:pointer;font-size:0.8rem;border-bottom:2px solid transparent">Initial Design</button></div>';
    } else if (hasFonts || hasInits) {
      html += '<p style="font-size:0.7rem;letter-spacing:0.1em;text-transform:uppercase;color:#666;margin:0.75rem 0 0.5rem">' + (hasFonts ? 'Font Style' : 'Initial Design') + '</p>';
    }

    html += '<div id="pane-fonts"' + (hasFonts ? '' : ' style="display:none"') + '>' + _sharedFontGrid() + '</div>';
    html += '<div id="pane-initials"' + (hasFonts || !hasInits ? ' style="display:none"' : '') + '>' + _sharedInitGrid() + '</div>';
    if (isMulti) html += '<div id="pers-summary" style="font-size:0.75rem;color:#7a6a5a;margin:0.75rem 0 0;min-height:1.2em"></div>';
    html += '<button type="button" id="pers-save-btn" style="width:100%;background:#2c0f0f;color:#fff;padding:14px;border:none;cursor:pointer;margin-top:1rem;letter-spacing:0.08em;font-size:0.85rem">' + (editCartKey ? 'UPDATE CART' : 'ADD TO CART') + '</button>';
    html += '</div>';
    formEl.innerHTML = html;

    activateField(activeField);

    document.getElementById('pers-back-lnk').addEventListener('click', function(e) { e.preventDefault(); renderStep1(); });

    rawFields.forEach(function(fid) {
      var inp = getInp(fid), ctr = getCtr(fid);
      if (!inp) return;
      inp.addEventListener('focus', function() { activateField(fid); });
      inp.addEventListener('input', function() { if (ctr) ctr.textContent = inp.value.length + '/' + inp.maxLength; });
    });

    formEl.querySelectorAll('.pers-toggle-pill').forEach(function(btn) {
      btn.addEventListener('click', function() { activateField(btn.dataset.field); });
    });

    formEl.querySelectorAll('.pers-tab-btn').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var tabType = tab.dataset.tab;
        formEl.querySelectorAll('.pers-tab-btn').forEach(function(t) { t.style.borderBottom='2px solid transparent'; t.style.fontWeight=''; });
        tab.style.borderBottom = '2px solid #2c0f0f'; tab.style.fontWeight = '600';
        var fp = document.getElementById('pane-fonts'), ip = document.getElementById('pane-initials');
        if (fp) fp.style.display = tabType==='fonts' ? '' : 'none';
        if (ip) ip.style.display = tabType==='initials' ? '' : 'none';
      });
    });

    formEl.querySelectorAll('.pers-style-card').forEach(function(card) {
      card.addEventListener('click', function() {
        var cardId = card.dataset.cardId, type = card.dataset.type, maxChars = parseInt(card.dataset.max)||500, label = card.dataset.label;
        selections[activeField] = { id: cardId, type: type, label: label };
        refreshOutlines();
        renderSummary();
        setFieldStyleLabel(activeField, label);

        var inp = getInp(activeField);
        if (inp) {
          if (type === 'font') {
            var mf = fonts.find(function(f) { return f.id === cardId; });
            unlockFieldInput(activeField, mf && mf.fontFamily ? mf.fontFamily : '');
            inp.maxLength = 500;
            var ctr = getCtr(activeField);
            if (ctr) ctr.textContent = inp.value.length + '/500';
          } else if (type === 'initial') {
            unlockFieldInput(activeField, '');
            applyInitialLimit(activeField, maxChars);
            if (card.dataset.hint) inp.placeholder = card.dataset.hint;
          }
          setTimeout(function() { inp.focus(); }, 50);
        }
      });
    });

    document.getElementById('pers-save-btn').addEventListener('click', function() {
      // Check all fields have style selected
      var allSelected = rawFields.every(function(fid) {
        var inp = getInp(fid);
        return inp && !inp.hasAttribute('readonly');
      });
      if (!allSelected) {
        var grid = formEl.querySelector('#pane-fonts') || formEl.querySelector('#pane-initials');
        if (grid) {
          grid.style.transition = 'transform 0.1s';
          grid.style.transform = 'translateX(6px)';
          setTimeout(function() { grid.style.transform = 'translateX(-6px)'; }, 100);
          setTimeout(function() { grid.style.transform = 'translateX(4px)'; }, 200);
          setTimeout(function() { grid.style.transform = 'translateX(0)'; }, 300);
        }
        var w = formEl.querySelector('#pers-font-warning');
        if (!w) {
          w = document.createElement('p');
          w.id = 'pers-font-warning';
          w.style.cssText = 'font-size:11px;color:#c0392b;margin:6px 0 0;text-align:center;';
          w.textContent = 'Please select a font style for each text field.';
          var sb = document.getElementById('pers-save-btn');
          if (sb) sb.parentNode.insertBefore(w, sb);
        }
        return;
      }

      var firstInp = getInp(rawFields[0]);
      var firstText = firstInp ? firstInp.value.trim() : '';
      if (!firstText) { if (firstInp) firstInp.focus(); return; }

      var parts = rawFields.map(function(fid) {
        var inp = getInp(fid), text = inp ? inp.value.trim() : '';
        var sel = selections[fid], name = SAVE_NAMES[fid] || fid;
        return name + ': ' + (sel ? (sel.type==='font' ? 'Font ' : 'Initial ') + sel.label : '\u2013') + ' | Text: ' + (text || '\u2013');
      });
      var persText = sideLabel + ' | ' + parts.join(' | ');

      var persHidden = document.getElementById('pdp-pers-hidden');
      var fontHidden = document.getElementById('pdp-font-hidden');
      if (persHidden) persHidden.value = persText;
      if (fontHidden) fontHidden.value = (selections[rawFields[0]]||{}).label || '';

      var vi = document.getElementById('pdp-variant-id');
      var allVars = window.jabVariants || variants;
      var match = null;
      var current = allVars.find(function(v) { return v.id === parseInt(vi && vi.value); });
      var OPTS = ['option1', 'option2', 'option3'];

      // Detect which option slot holds the personalization values
      var persOpt = null;
      OPTS.forEach(function(o) {
        if (!persOpt && allVars.some(function(v) { return v[o] === sideValue; })) persOpt = o;
      });

      if (persOpt) {
        match = allVars.find(function(v) {
          return OPTS.every(function(o) {
            if (v[o] == null) return true;
            if (o === persOpt) return v[o] === sideValue;
            return !current || v[o] === current[o];
          });
        });
      }
      if (!match) {
        console.warn('[JabaPers] No matching personalized variant for:', sideValue);
      }
      if (match) {
        if (vi) { vi.value = match.id; vi.dispatchEvent(new Event('change',{bubbles:true})); }
        document.querySelectorAll('.pdp__price, [data-pdp-price]').forEach(function(el) { el.textContent = '$' + (match.price/100).toFixed(2).replace('.00',''); });
      }

      var sumEl = document.getElementById('pdp-pers-sum');
      var persBtn = document.getElementById('pdp-pers-btn');
      var sumText = document.getElementById('pdp-pers-sum-text');
      if (sumText) sumText.textContent = persText;
      if (sumEl) sumEl.hidden = false;
      if (persBtn) {
        persBtn.hidden = false;
        persBtn.textContent = 'Edit Personalization';
      }

      closePanel();

      (function() {
        var variantId = parseInt(document.getElementById('pdp-variant-id').value);
        var qty = parseInt((document.getElementById('pdp-qty')||{}).value) || 1;
        var ph = document.getElementById('pdp-pers-hidden');
        var props = {};
        if (ph && ph.value) props['Personalization'] = ph.value;

        var savedEditKey = editCartKey; // capture before reset
        editCartKey = null; // reset state regardless of outcome

        if (savedEditKey) {
          // EDIT MODE: delete old line item, then add new, then redirect to cart
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: savedEditKey, quantity: 0 })
          }).then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: qty, properties: props })
            });
          }).then(function() {
            window.location.href = '/cart';
          }).catch(function(err) {
            console.error('[JabaPers] Edit-update error:', err);
          });
        } else {
          // NORMAL MODE: add to cart and open drawer
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty, properties: props })
          }).then(function() {
            var openBtn = document.querySelector('[data-open-cart]');
            if (openBtn) openBtn.click();
          }).catch(function(err) { console.error('[JabaPers] ATC error:', err); });
        }
      })();
    });
  }

  // Trigger
  triggerBtn.addEventListener('click', function(e) {
    e.preventDefault();
    buildIfNeeded();
    if (!panel.classList.contains('is-open')) {
      panel.classList.add('is-open');
      panel.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }
  });
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closePanel(); });

  // ═══ BRIDGE: openWithPrefill — called by product.liquid edit handler ═══
  window.JabaPersPanel = window.JabaPersPanel || {};
  window.JabaPersPanel.openWithPrefill = function(prefillData, editKey) {
    editCartKey = editKey || null;
    // prefillData = { sideLabel: "Both Sides Engraving", fields: { front: {styleType:'Font', styleLabel:'#1 Times New Roman', text:'HELLO'}, back: {...} } }
    if (!prefillData || !prefillData.sideLabel) {
      // No data — fallback to normal Step 1 open
      buildIfNeeded();
      panel.classList.add('is-open');
      panel.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      return;
    }

    // Find matching sideObj by label match (case-insensitive, includes)
    var sides = (config.engravingSides || []);
    var sideLabelLower = prefillData.sideLabel.toLowerCase();
    var sideObj = sides.find(function(s) {
      var lbl = (s.label || s.value || '').toLowerCase();
      // Match if label includes our string or vice versa (handles "Both Sides" vs "Both Sides Engraving")
      return lbl === sideLabelLower || lbl.indexOf(sideLabelLower) !== -1 || sideLabelLower.indexOf(lbl) !== -1;
    });

    if (!sideObj) {
      console.warn('[JabaPers] Edit: no matching sideObj for label:', prefillData.sideLabel, '— falling back to Step 1');
      buildIfNeeded();
      panel.classList.add('is-open');
      panel.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      return;
    }

    // Open panel
    panel.classList.add('is-open');
    panel.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    // Render Step 2 directly with the matched sideObj
    renderStep2(sideObj);

    // Wait for DOM to be ready, then prefill fields
    setTimeout(function() {
      var fields = prefillData.fields || {};
      Object.keys(fields).forEach(function(fid) {
        var fieldData = fields[fid];
        if (!fieldData) return;

        // 1. Switch to this field via the toggle pill
        var pill = formEl.querySelector('.pers-toggle-pill[data-field="' + fid + '"]');
        if (pill) pill.click();

        // 2. Click the matching style card (font or initial)
        if (fieldData.styleLabel) {
          var labelLower = fieldData.styleLabel.toLowerCase().trim();
          var styleCards = formEl.querySelectorAll('.pers-style-card');
          var matched = null;
          styleCards.forEach(function(card) {
            var cardLabel = (card.dataset.label || card.textContent || '').toLowerCase().trim();
            if (cardLabel === labelLower || cardLabel.indexOf(labelLower) !== -1) {
              if (!matched) matched = card;
            }
          });
          if (matched) matched.click();
        }

        // 3. Set the input value
        var inp = document.getElementById('pfield-' + fid);
        if (inp && fieldData.text) {
          // Remove readonly if still locked
          inp.removeAttribute('readonly');
          inp.style.background = '#fff';
          inp.style.color = '#000';
          inp.style.cursor = 'text';
          inp.value = fieldData.text;
          // Trigger input event for char counter update
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      // After all prefill, switch back to first field
      var firstFid = Object.keys(fields)[0];
      if (firstFid) {
        var firstPill = formEl.querySelector('.pers-toggle-pill[data-field="' + firstFid + '"]');
        if (firstPill) firstPill.click();
      }
    }, 50);
  };

});
